import VueI18n from 'vue-i18n';

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    en: {
      normal_download: 'Normal download',
      training_data_download: 'Training data download',
    },
    ja: {
      normal_download: '通常ダウンロード',
      training_data_download: '教師データダウンロード',
    },
  },
});

export default {
  computed: {
    downloadOptions() {
      // 教師データは admin の代理ログイン中だけ選べる。代理店の代理ログインでは出さない
      if (!this.$store.getters.assumedByAdmin) {
        return [];
      }

      return [
        { type: 'normal', label: i18n.t('normal_download', this.$i18n.locale) },
        { type: 'trainingData', label: i18n.t('training_data_download', this.$i18n.locale) },
      ];
    },
  },
};
